module.exports = __webpack_public_path__ + "img/avatar0.17ea1c03.png";